import React from 'react';
import Navigation from '../navbar'
import Footer from '../footer';
import BoardImage from '../assets/boardmembers.jpg'
import Leadership from '../assets/Executive Management.jpeg'
import { useNavigate } from 'react-router-dom';
import Totobi from '../assets/board/Totobi Quakyi.png'
import Samuel from '../assets/board/Samuel Borlu.png'
import Nasira from '../assets/board/Nasira Afrah Gyekye.png'
import Emmanuel from '../assets/board/Emmanuel Vincent.png'
import Charlotte from '../assets/board/Charlotte Osei.png'
import Blay from '../assets/board/Blay Nyamekye Armah.png'
import Baba from '../assets/board/Baba Abdul Jamal Adama.png'
import Awulae from '../assets/board/Awulae Agyefi Kwame.png'
import Judith from '../assets/board/Judith Blay.png'
import Susan from '../assets/leadership/susan.png'


function Board() {
  let navigate = useNavigate();

  const People = () => {
    navigate("/management")
  }
  const Leaders = () => {
    navigate("/leadership")
  }
  return (
    <>
      <Navigation />
      <div className="relative">
        <div className="absolute inset-0 bg-black bg-opacity-50 flex">
          <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mx-[270px]">

          </h1>
        </div>
        <img
          className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover object-top sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover md:object-top lg:w-full lg:h-[500px] xl:w-full 4K:object-cover 4K:object-top"
          src={BoardImage}
          alt="Ghana Gas GPP"
        />
      </div>

      <h1 className="font-fjalla text-gasblue text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:m-10 xl:text-5xl xl:mx-[270px] xl:mt-[100px]">
        Board of Directors
      </h1>

      <div class="grid md:grid-cols-3 gap-4 phone: grid-cols-2">
        <div class="col-span-1 flex items-center justify-end">
          <img src={Totobi} alt="CEO Image" className='scale-75' />
        </div>
        <div class="col-span-2 flex items-center hover:cursor-pointer" >
          <div>
            <p class="text-black font-fjalla text-[24px] md:mx-20 phone:mx-10">Mr. Kofi Totobi Quakyi </p>
            <p class="text-black font-fira text-[20px] md:ms-20 phone:mx-10">Board Chairman</p>
            <p class="text-black font-fira md:text-[19px] phone:text-[15px] phone:mx-10 md:mx-20 text-justify leading-snug">

            </p>
            <br />
          </div>
        </div>
      </div>

      <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 xl:px-[12rem] xl:pt-[8rem]">
        <div className='flex flex-col items-center text-center hover:cursor-pointer' >
          <img src={Judith} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Ms. Judith Adjobah Blay </span>
          <span className='font-fira text-[17px]'>Chief Executive Officer</span>
        </div>

        <div className='flex flex-col items-center text-center hover:cursor-pointer' >
          <img src={Emmanuel} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Mr. Emmanuel Vincent</span>
          <span className='font-fira text-[17px]'>Member</span>
        </div>

      </div>      <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 xl:px-[12rem] xl:pt-[8rem]">
        <div className='flex flex-col items-center text-center hover:cursor-pointer' >
          <img src={Nasira} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Ms. Nasira Afrah Gyekye (MP)</span>
          <span className='font-fira text-[17px]'>Member</span>
        </div>
        <div className='flex flex-col items-center text-center hover:cursor-pointer' >
          <img src={Charlotte} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Ms. Charlotte Osei</span>
          <span className='font-fira text-[17px]'>Member</span>
        </div>
      </div>

      <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 xl:px-[12rem] xl:pt-[8rem]">
        <div className='flex flex-col items-center text-center hover:cursor-pointer' >
          <img src={Samuel} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Mr. Samuel Kwame Borlu</span>
          <span className='font-fira text-[17px]'>Member</span>
        </div>
        <div className='flex flex-col items-center text-center hover:cursor-pointer' >
          <img src={Awulae} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Awulae Agyefi Kwame II</span>
          <span className='font-fira text-[17px]'>Member</span>
        </div>
      </div>
      <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 xl:px-[12rem] xl:pt-[8rem]">
        <div className='flex flex-col items-center text-center hover:cursor-pointer' >
          <img src={Baba} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Mr. Baba Abdul Jamal Adama</span>
          <span className='font-fira text-[17px]'>Member</span>
        </div>
        <div className='flex flex-col items-center text-center hover:cursor-pointer' >
          <img src={Blay} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Mr. Blay Nyameke Armah (MP)</span>
          <span className='font-fira text-[17px]'>Member</span>
        </div>
      </div>
      <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 xl:px-[12rem] xl:pt-[8rem]">
        <div className='flex flex-col items-center text-center hover:cursor-pointer' >
          <img src={Susan} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Ms. Susan Kafui Gbemu</span>
          <span className='font-fira text-[17px]'>Company Secretary</span>
        </div>
        
      </div>
      <br />
      <br />

      <div className="relative hover:cursor-pointer" onClick={Leaders}>
        <div className="absolute inset-y-0 inset-x-1/2 left-0 bg-black bg-opacity-50 flex">
          <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mt-30 xl:ml-30">
            Executive Management
          </h1>
        </div>
        <img
          className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[400px] xl:w-full xl:"
          src={Leadership}
          alt="Ghana Gas GPP"
        />
      </div>

      <div className="relative hover:cursor-pointer" onClick={People}>
        <div className="absolute inset-y-0 inset-x-1/2 right-0 bg-black bg-opacity-50 flex">
          <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mt-30 xl:ml-30">
            Management
          </h1>
        </div>
        <img
          className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[400px] xl:w-full xl:h-[]"
          src={Leadership}
          alt="Ghana Gas GPP"
        />
      </div>

      <Footer />

    </>
  )
}

export default Board;